import { Validators } from '@angular/forms';

export class IncomeDetailsModel {
  companyIncomeList = {
    value: [],
    validation: Validators.compose([]),
  };

  trustIncomeList = {
    value: [],
    validation: Validators.compose([]),
  };
}

export class BusinessIncomeModel {
  previousYearIncome = {
    value: null,
    validation: Validators.compose([])
  };
  previousYearTotalIncome = {
    value: null,
    validation: Validators.compose([])
  };
  currentYearIncome = {
    value: null,
    validation: Validators.compose([])
  };
  currentYearTotalIncome = {
    value: null,
    validation: Validators.compose([])
  };
  link = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  parent = {
    value: true,
    validation: Validators.compose([]),
    disabled: true
  };
  allowableAddBacks = {
    value: [],
    validation: Validators.compose([])
  };
  basIncomeType = {
    value: 'business-income',
    validation: Validators.compose([])
  };
  mostRecentBasPeriod = {
    value: null,
    validation: Validators.compose([])
  };
  basQuarters = {
    value: [],
    validation: Validators.compose([])
  };
  numberOfQuarters = {
    value: 2,
    validation: Validators.compose([Validators.required])
  };
}
